import React from "react";
import PropTypes from "prop-types";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import { Warning as WarningIcon } from "@mui/icons-material";

const SessionWarning = ({ open, onExtendSession, onLogout }) => {
  const { t } = useTranslation("userTranslation");

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          pb: 1,
        }}
      >
        <WarningIcon color="warning" />
        <Typography variant="h6" component="span">
          {t("session.warningTitle", "Session Timeout Warning")}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography variant="body1">
            {t(
              "session.warningMessage",
              "Your session will expire soon due to inactivity."
            )}
          </Typography>
        </Alert>

        <Typography variant="body2" sx={{ mt: 2, textAlign: "center" }}>
          {t(
            "session.warningInstruction",
            "Click 'Stay Logged In' to continue your session or 'Logout' to sign out now."
          )}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button onClick={onLogout} color="inherit" variant="outlined">
          {t("session.logout", "Logout")}
        </Button>
        <Button onClick={onExtendSession} color="primary" variant="contained">
          {t("session.extendSession", "Stay Logged In")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

SessionWarning.propTypes = {
  open: PropTypes.bool.isRequired,
  onExtendSession: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
};

export default SessionWarning;
